module.exports = __webpack_public_path__ + "img/Expo_Topic6.18c6a7f2.png";